import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon } from "lucide-react";
import { specialites } from "../data/specialites";
const WORKSHOP_IMAGE = "https://cdn.magicpatterns.com/patterns/generated-images/55ad60ba-395c-433e-8d38-1a10ffb6e95b.jpg";
export function Specialites() {
  return <section aria-labelledby="specialites-title" className="bg-ink py-20 text-sand md:py-28" data-id="element-161" data-mp="cjm2sczmzrp">
      <div className="mx-auto grid max-w-site gap-14 px-5 md:px-8 lg:grid-cols-12 lg:gap-20" data-id="element-162" data-mp="ebsrcwzno9gw">
        <div className="lg:col-span-5" data-id="element-163" data-mp="absfnk3xycdj">
          <h2 id="specialites-title" className="font-display text-4xl font-medium tracking-tight text-white md:text-6xl" data-id="element-164" data-mp="aaqs4g5qnxex">
            Nos spécialités
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-sand/75" data-id="element-165" data-mp="j315u7fuel0x">
            Explorez les possibilités infinies pour l'équipement de votre van. De la banquette-lit douillette à la cuisine fonctionnelle, du toit relevable à l'isolation premium, jusqu'à l'installation électrique complète et les panneaux solaires.
          </p>
          <figure className="mt-10 overflow-hidden rounded-3xl" data-id="element-166" data-mp="1wx2ju5yip4cx">
            <img src={WORKSHOP_IMAGE} alt="Artisan de l'atelier MANY Loisirs posant du mobilier bois dans un van" className="aspect-[3/2] w-full object-cover" data-id="element-167" data-mp="21tsxkmmunnv6" />
          </figure>
        </div>

        <ul className="border-t border-white/15 lg:col-span-7 lg:self-center" data-id="element-168" data-mp="2aviycj2mfz5m">
          {specialites.map(({
          icon: Icon,
          title,
          text,
          href
        }) => <li key={href} className="border-b border-white/15" data-id="element-169" data-mp="2fs9dn46lqqpz">
              <Link to={href} className="group flex items-center gap-5 py-6 md:gap-8 md:py-7" data-id="element-170" data-mp="2ksf085y0ln17">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-white/20 text-sand transition-colors duration-150 group-hover:border-clay group-hover:bg-clay group-hover:text-white" data-id="element-171" data-mp="2pl83sqhqypbp">
                  <Icon className="h-5 w-5" strokeWidth={1.75} aria-hidden="true" data-id="element-172" data-mp="2ymoaan5fy7an" />
                </span>
                <span className="flex-1" data-id="element-173" data-mp="33htyjsmbfy1w">
                  <span className="block font-display text-2xl font-medium text-white md:text-3xl" data-id="element-174" data-mp="13h5e1g6u8o9y">{title}</span>
                  <span className="mt-1 block text-[15px] text-sand/65" data-id="element-175" data-mp="yjn71vcdsj4l">{text}</span>
                </span>
                <ArrowRightIcon className="h-5 w-5 shrink-0 text-sand/50 transition-[transform,color] duration-200 group-hover:translate-x-1 group-hover:text-white" aria-hidden="true" data-id="element-176" data-mp="1d89wipvq2r9j" />
              </Link>
            </li>)}
        </ul>
      </div>
    </section>;
}